import React from 'react';
import { Router, Route, IndexRoute } from 'react-router';
import Auth from './utils/auth.js';
// Main layout
import App from './components/App';
import SignedInNav from './components/SignedInNav.js';
import SignedOutNav from './components/SignedOutNav.js';
// Support pages
import Login from './components/Login';
import Logout from './components/Logout';
import NotFound from './components/NotFound';
// Content pages
import Home from './components/Home';

const auth = new Auth();

const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={App} onEnter={auth.requireAuth}>
      <IndexRoute components={{ content: Home, navbar: SignedInNav }}/>
    </Route>
    <Route path="/login" component={App}>
      <IndexRoute components={{ content: Login, navbar: SignedOutNav }}/>
    </Route>
    <Route path="/logout" component={Logout} />
    <Route path="*" component={NotFound} />
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js